import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"
import PaymentLink from "src/main/Billing/Links/PaymentLink"
import { formatDay } from "src/main/Billing/PaymentDetail/helpers"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const InvoicePayments = ({ payments }) => {
  const { presentmentCurrency } = useMarina()

  return (
    <section aria-labelledby="invoice-payments-heading">
      <h2
        id="invoice-payments-heading"
        className="mb-2 mt-0 text-base font-semibold text-gray-900"
      >
        Payments
      </h2>
      {payments.length === 0 ? (
        <p className="m-0 text-sm text-gray-700">No payments yet</p>
      ) : (
        <ul className="m-0 list-none divide-y divide-gray-200 rounded border border-gray-200 p-0">
          {payments.map((payment) => (
            <li
              key={payment.id}
              className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-3 text-sm"
            >
              <PaymentLink
                paymentTxnId={payment.id}
                href={payment.paymentPath}
                className="font-semibold text-blue-600"
              >
                {payment.displaySequentialId || "Payment"}
              </PaymentLink>
              <span className="text-gray-700">
                {formatDay(payment.occurredOn)}
              </span>
              <span className="text-gray-900">
                {formatCurrencyFromMinorUnits({
                  amount: payment.amountCents,
                  currency: presentmentCurrency,
                })}
              </span>
              <span className="text-gray-700">{payment.statusLabel}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}

InvoicePayments.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      displaySequentialId: PropTypes.string,
      occurredOn: PropTypes.string.isRequired,
      amountCents: PropTypes.number.isRequired,
      statusLabel: PropTypes.string.isRequired,
      paymentPath: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default InvoicePayments
